// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-edc53f60]{width:420px}form[data-v-edc53f60]{width:100%;margin-top:40px}form .input[data-v-edc53f60]:first-child{margin-bottom:15px}form .btn[data-v-edc53f60]{margin-top:20px;width:100%}form .attempts-error[data-v-edc53f60]{width:100%;text-align:center;color:#e1b048;margin:16px 0}.logo[data-v-edc53f60]{width:160px;height:60px}", ""]);
// Exports
module.exports = exports;
